import { FC, FormEvent, useState } from "react";
import { useNavigate } from "react-router";

import {
  InputFormElement,
  SelectFormElement,
  SubmitFormElement,
  roles,
} from "../general";
import { ErrorWrapper } from "../wrappers";
import { auth, updateProfile } from "../../firebase";
import { useApi } from "../../api";
import { DEFAULT_ERROR_WITH_SUGGESTION_MESSAGE } from "../../ui/constants";

export const CompleteProfileForm: FC = () => {
  const [name, setName] = useState("");
  const [position, setPosition] = useState("");
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  const navigate = useNavigate();
  const { getApi } = useApi();

  const handleCompleteProfile = async (event: FormEvent) => {
    event.preventDefault();
    const currentUser = auth.currentUser;
    if (!currentUser) {
      navigate("/auth/signin");
      return;
    }

    setErrorMessage("");
    setLoading(true);
    try {
      if (name) {
        await updateProfile(currentUser, { displayName: name });
      }
      if (position) {
        const api = await getApi();
        await api.setUserPosition(currentUser.uid, { position });
      }
      navigate("/");
    } catch (error) {
      setErrorMessage(DEFAULT_ERROR_WITH_SUGGESTION_MESSAGE);
      setLoading(false);
    }
  };

  return (
    <ErrorWrapper errorMessage={errorMessage}>
      <form onSubmit={handleCompleteProfile}>
        <InputFormElement
          value={name}
          setValue={(value) => setName(value.toString())}
          currentStep={{
            name: "userDisplayName",
            title: "Name",
            type: "text",
            required: false,
          }}
        />
        <SelectFormElement
          value={position}
          setValue={(value) => setPosition(value.toString())}
          currentStep={{
            name: "position",
            title: "Role",
            type: "select",
            cases: roles,
            required: false,
          }}
        />
        <SubmitFormElement
          submitTitle={loading ? "Please wait…" : "Finish setup"}
          disabled={loading}
        />
      </form>
    </ErrorWrapper>
  );
};
